module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAFCAYAAAB8ZH1oAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAClJREFUeNpi+P////z/hMF8BhAgoBiiCAZwKEZVhEMxdkVoijEUAQQYACimc8mNnpRKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/down-caret.png
// module id = 2747
// module chunks = 1